<div>
  @switch (type()) {
    @case ('warning') {
      <mat-icon fontIcon="report" />
    }
    @case ('info') {
      <mat-icon fontIcon="info" />
    }
  }
</div>

<ng-content />
